import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Lila Kağıt',
  logo: { name: 'Lila Kağıt', src: '/logo/lilakagitcard.png' },
  portrait: { src: '/photo/portrait-tarkan-atesoglu.png', alt: 'Tarkan Ateşoğlu' },
  quote: [
    'The digital maturity assessment has been a crucial tool in mobilizing our departments '
    + 'towards common goals.',
    'Thanks to Digitopia’s Digital Maturity Index, we gained a clear understanding of our '
    + 'position in key areas such as customer, governance, operations, people, innovation, '
    + 'and technology.',
    'With the guidance of a moderator and the competitive insights provided, our teams were '
    + 'able to position themselves within the market and take ownership of their '
    + 'transformation steps. We ensured accountability across departments and achieved '
    + 'strategic alignment.',
  ],
  attribution: 'Tarkan Ateşoğlu, Information Technology Group Manager',
  story: 'lila-kagit',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 6
